import * as React from 'react';
import { Box, Dialog, Hidden, IconPersonAdd, Text } from 'braid-design-system';
import { IconWithText } from 'src/components/common/IconTextLink';
import { useStores } from 'src/utils/hooks/useStores';
import AddCandidateForm, {
  type AddCandidate,
} from 'src/components/app/AddCandidate/AddCandidateForm';
import { trackAddCandidateClickedEvent } from '../../../../utils/events/addCandidateEvents';
import { useIconLabel } from 'src/components/common/IconTextLink/hooks/useIconLabel';
import { useTranslations } from '@vocab/react';
import translations from '../.vocab';
import { useAppConfig } from 'src/constants/AppConfig/AppConfigProvider';

export const AddCandidateAction: React.FC<{
  addCandidate: AddCandidate;
}> = ({ addCandidate }) => {
  const { jobApplicationStore } = useStores();
  const { locale } = useAppConfig();

  const [showForm, setShowForm] = React.useState(false);
  const { getLabel } = useIconLabel();
  const { t } = useTranslations(translations);
  const addCandidateLabel = getLabel('Add a Candidate');
  return (
    <>
      <Box display="flex" justifyContent="flexEnd" flexGrow={1}>
        <Hidden below="tablet">
          <Box
            cursor="pointer"
            onClick={() => {
              setShowForm(true);
              trackAddCandidateClickedEvent({});
            }}
          >
            <Text baseline={false} weight="medium">
              <IconWithText
                icon={<IconPersonAdd />}
                label={addCandidateLabel}
              />
            </Text>
          </Box>
        </Hidden>
      </Box>
      <Dialog
        id="add-candidate-modal"
        open={showForm}
        onClose={() => setShowForm(false)}
        width="medium"
        title={t('Add a Candidate')}
        closeLabel={t('Close')}
      >
        <AddCandidateForm
          addCandidate={addCandidate}
          jobApplicationStore={jobApplicationStore}
          onClose={() => setShowForm(false)}
          locale={locale}
        />
      </Dialog>
    </>
  );
};
